var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Select",
    {
      model: {
        value: _vm.selected,
        callback: function ($$v) {
          _vm.selected = $$v
        },
        expression: "selected",
      },
    },
    _vm._l(_vm.timezones, function (timezone) {
      return _c(
        "option",
        { key: timezone.id, domProps: { value: timezone.id } },
        [_vm._v("\n        " + _vm._s(timezone.label) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }